module.exports = __webpack_public_path__ + "img/jiangpai-2.cf420974.svg";